// extracted by mini-css-extract-plugin
export default {"slideCardWrap":"SlideCard_slideCardWrap__6nkli","overlayName":"SlideCard_overlayName__+QSai","stickerCard":"SlideCard_stickerCard__vYNis"};